<template>
  <div class="tableWithPerPageSelection">
    <a ref="lienDownload"></a>
    <div class="level mgt-20px">
      <div class="level-left">
        <div class="columns">
          <div class="column is-narrow">
            <selecteur-action
              @handleAction="manageActions"
              :options='actions'
              :placeholder='$t("general.placeHolder.groupedAction")'
              :titleButton="'general.button.apply'"
              :elementsSelectionnes="dispositifsSelectedIsEmpty">
            </selecteur-action>
          </div>
          <form @submit.prevent="recherche()" class="column is-narrow">
            <b-input :placeholder="$t('general.button.search')" type="search" icon="magnify"
                     v-model="criteresRecherche.auto">
            </b-input>
          </form>
          <div class="column is-narrow">
            <button class="button" @click="setShowFiltre">
              <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
              <span class="is-size-7">
                {{$t('general.button.filtre')}}
                <label class="has-text-weight-bold"
                       :class="getFilteredNumber > 0 ? '' : 'is-invisible'">
                  ({{ getFilteredNumber }})
                </label>
              </span>
            </button>
            <span @click="reinitialiserFiltre()"
                  class="info-circle-right is-pulled-right is-cursor-pointer">
              <b-icon icon="close-circle" type="is-danger"></b-icon>
            </span>
          </div>
        </div>
      </div>
      <div class="columns level-right">
        <b-field v-if="!isSelectable" class="column mg-0">
          <b-checkbox-button
            v-model="withoutImage"
            @input="recherche"
            type="is-primary"
            outlined>
            <b-icon
              :icon="withoutImage ? 'image-off-outline' : 'image-outline'"
              class="mg-0">
            </b-icon>
          </b-checkbox-button>
        </b-field>
        <div v-if="!isSelectable" class="column is-narrow">
          <exportExcelButton
            :perm="permEmplacement.exporter"
            :query="exportExcelQuery"
            :secondaryExports="secondaryActions">
          </exportExcelButton>
        </div>
        <parametrage-table
          :reference-table="referenceTable"
          @endLoadParamtre="startArrayRendering = true">
        </parametrage-table>
      </div>
    </div>
    <div class="column is-12 is-paddingless mgb-20px" v-if="errors.length > 0">
      <error-msg-component :messages="errors"
                           :error="errors.length > 0"
                           :title="'general.problemOccurred'"
                           :withEmplyFields="true"
                           @close="errors = []"/>
    </div>
    <v-server-table
      url=""
      :columns="columns"
      :options="options"
      :ref="referenceTable"
      @loaded="finLoading"
      @loading="debutLoading"
      v-if="startArrayRendering && mountedLoadingEnd">
      <template slot='afterTable'>
        <table-items-in-view
          :perPage="resultPerPage"
          @input="$refs[referenceTable].setLimit($event)"/>
      </template>
      <div slot="selected" slot-scope="props" class="has-text-centered">
          <qd-checkbox v-model="props.row.selected">
          </qd-checkbox>
      </div>
      <div slot="addSelection" slot-scope="props">
        <b-tooltip :label="$t(getSelectionButtonMessage(props.row))"
                   :type="getSelectionButtonColor(props.row)">
          <button
            @click="$emit(
            isInSelection(props.row) ? 'removeSelection' : 'addSelection',
            [props.row],
          )"
            class="ripple button width-100percent"
            :class="getSelectionButtonColor(props.row)">
            <b-icon icon="plus-circle"></b-icon>
          </button>
        </b-tooltip>
      </div>
      <div slot="code" slot-scope="props">
        <section class="is-flex is-justify-content-space-between">
          <router-link :to="{ name: 'c.gabed.emplacement-detailDispositif',
            params: { id: props.row.emplacementId,
            idDispositif: props.row.id }}"
            class="lien"
            :class="{'text-access-no-permission':
            !checkPermissions(permEmplacement.lecture)}">
            {{ props.row.code }}
          </router-link>
          <tag-list class="is-justify-content-flex-end"
            v-if="getListeTags(props.row.tags).length > 0"
            :listes="getListeTags(props.row.tags)"/>
        </section>
      </div>
      <div slot="image" slot-scope="props" class="has-text-centered">
        <image-view
          :permission="permEmplacement"
          :image="props.row.cheminMin"
          :imageTooltip="props.row.chemin"
          :id="props.row.id"
          :libelle="props.row.code"
        />
      </div>
      <div slot="adresse.adresse1" slot-scope="props">
        {{ props.row.adresse | adresse }}
      </div>
      <div slot="emplacement.client.nomCommercial" slot-scope="props"
           v-if="moduleEmplacementClientActive && hasClient(props.row)">
        <router-link-blank
          :to="{
            name: 'c.bodac.clients/contacts-client',
            params: { id: getClientId(props.row) } }"
          :message="getNomClient(props.row)"
          :class="{'text-access-no-permission': !checkPermissions(permEmplacement.lecture)}">
        </router-link-blank>
      </div>
      <div slot="etat" slot-scope="props">
        {{ $t(getEtatMontage(props.row.etat)) }}
      </div>
      <div slot="dispositifType.libelle" slot-scope="props">
        {{ getDispositifTypeLibelle(props.row.dispositifTypeId) }}
      </div>
      <div slot="agence" slot-scope="props">
        {{ getAgenceLibelle(props.row.emplacement.agenceId) }}
      </div>
      <div slot="actif" slot-scope="props">
        {{ props.row.actif ? $t('general.non') : $t('general.oui') }}
      </div>
      <div slot="dispositifSupport.libelle" slot-scope="props">
        {{ props.row.dispositifSupport ? props.row.dispositifSupport.libelle : '' }}
      </div>
      <div slot="edit" slot-scope="props">
        <btn-action-icon
          :tooltip-label="$t('general.button.edit')"
          :permission="permEmplacement.maj"
          @is-click="$router.push({ name: 'm.gabed.emplacement-dispositifPublicitaireEdition',
                    params: { idDispositif: props.row.id }})"
          icon-type="is-success"
          icon="pencil-box-outline">
        </btn-action-icon>
      </div>
      <div slot="archiver" slot-scope="props">
        <btn-action-icon
          :tooltip-label="props.row.actif
            ? $t('general.button.archiver') : $t('general.button.desarchiver')"
          :permission="permEmplacement.supprimer"
          @is-click="showPopUpArchivage(props.row)"
          icon-type="is-default"
          :icon="props.row.actif ? 'archive' : 'archive-arrow-up'">
        </btn-action-icon>
      </div>
      <div slot="delete" slot-scope="props">
        <btn-action-icon
          :tooltip-label="$t('general.button.delete')"
          :permission="permEmplacement.supprimer"
          @is-click="showPopUpSuppression(props.row)"
          icon-type="is-danger"
          icon="delete-forever">
        </btn-action-icon>
      </div>
    </v-server-table>
    <transition name="custom-classes-transition"
                enter-active-class="animate__animated animate__slideInRight"
                leave-active-class="animate__animated animate__slideOutRight" :duration="10">
      <div class="componentBrief" v-show="showFiltre">
        <filtre-liste-dispositif @toggleFiltre="setShowFiltre"
                                 ref="filtreListeDispositif"
                            @recherche="makeRechercheFilter"/>
      </div>
    </transition>
    <b-modal v-model="openPopUpPrevention"
             has-modal-card
             class="modal">
      <pop-up-prevention
        v-if="openPopUpPrevention"
        @no="openPopUpPrevention = false;"
        @yes="archiverDispositif()"
        :messagesPopup="messagesErreurPopUp"
        :isErrorPopup.sync="errorPopUp"
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        :mess-header="$t(('listeDispositif.archivageDesarchiver.'
        + (isArchiveOrNot ? 'archivage' : 'desarchivage')))"
        :mess-footer="$t(('listeDispositif.infoArchivageDesarchivage.'
        + (isArchiveOrNot ? 'archivage' : 'desarchivage')))">
      </pop-up-prevention>
    </b-modal>
    <b-modal v-model="popUpChangementEtatEnMasse" has-modal-card
             class="modal">
      <pop-up-update-etat
        :messHeader="$t('dispositifPublicitaire.popUpSave.titleDemonte')"
        :etat="constantes.DEMONTE"
        :dispositifs="getAllDispositifSelected()"
        @validate="validationPopUp">
      </pop-up-update-etat>
    </b-modal>
    <b-modal
      v-model="popUpActionSecteur"
      has-modal-card
      class="modal"
      width="600px">
      <pop-up-manage-secteur
        :secteur-type="constantes.PATRIMOINE"
        :itemsIds="getAllDispositifSelected().map((el) => el.id)"
        :action-secteur="actionSecteur"
        :isAdd="actionSelected === constantes.ACTION_MASS_AJOUTER_SECTEUR"
        :translator="func.translatorSecteurDispositifs"
        :refresh="recherche"
        :validation="func.validationSecteur"
        @close="popUpActionSecteur = false"
      />
    </b-modal>
    <b-modal v-model="openPopUpImpressionEnMasse" has-modal-card class="modal">
      <pop-up-impression
        @close="closePopUpImpression()"
        @impression="(data) => genererImpresssions(data)">
      </pop-up-impression>
    </b-modal>
    <b-modal
      v-model="openPopUpPreventionSuppression"
      has-modal-card
      class="modal" @close="dispositifToDelete = null">
      <pop-up-prevention
        v-if="dispositifToDelete"
        @no="openPopUpPreventionSuppression = false; dispositifToDelete = null"
        @yes="supprimerDispositif"
        :messagesPopup="messagesErreurPopUp"
        :isErrorPopup.sync="errorPopUp"
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        :mess-header="$t('dispositifPublicitaire.supprimer.titre')"
        :mess-footer="$t('dispositifPublicitaire.supprimer.sousTitre')">
      </pop-up-prevention>
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import { EMPLACEMENT } from '@/configuration/gabed/permissionsGabedConf';
import subscribeMutation from '@/services/store/subscribeMutation';
import { SET_DETECT_CHANGE_SOCIETE, SET_LOCK_MENU } from '@/store/modules/societe-mutation-type';
import TableItemsInView from '@/components/general/TableItemsInView';
import {
  NO_PER_PAGE_VALUE,
  RESULTS_PER_PAGE,
  SORT_ICON,
  TEXTS,
} from '@/configuration/clientTableConf';
import { EPHEMERAL_DISPOSITIF_STORE, SELECTION_STATE } from '@/configuration/gabed/patrimoine/patrimoineConf';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import { ETAT_DISPOSITIF_PUBLICITAIRE, DEMONTE } from '@/configuration/gabed/dispositif/dispositifPublicitaire';
import { PARAMETRES_INTERNE_KEYS, PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import filtreListeDispositif from '@/components/gabed/dispositif/filtreListeDispositif';
import calculNombreCritere from '@/services/general/calculNombreCritere';
import formatIsoDate from '@/services/general/formatIsoDate';
import {
  FACE,
  MATERIEL,
  DISPOSITIF,
  TYPE_DONNEE_DISPOSITIF,
  TYPE_EXPORT_DISPOSITIF_TEMPS_FORT,
} from '@/configuration/gabed/emplacement/emplacementConf';
import inProgress from '@/services/general/inProgress';
import {
  archiverAll,
  ajoutSecteurAsync,
  suppressionSecteurAsync,
  genererDemandeImpression,
  supprimer,
} from '@/api/gabed/dispositif';
import messageSucces from '@/services/general/messageSucces';
import validationDispositif from '@/services/gabed/dispositif/validation';
import { columnsSplice } from '@/services/general/columns';
import popUpPrevention from '@/components/general/popUpPrevention';
import parametrageTable from '@/components/general/parametrageTable';
import imageView from '@/components/general/imageView';
import { REFERENCE_TABLE_DISPOSITIF } from '@/configuration/general/referenceTableConf';
import tagInputToArray from '@/services/general/filters/tagInputToArray';
import { get } from '@/api/tiers/index';
import tagList from '@/components/general/tagList';
import BtnActionIcon from '@/components/general/btnActionIcon';
import {
  ACTION_MASS_AJOUTER_SECTEUR,
  ACTION_MASS_SUPPRIMER_SECTEUR,
  ACTION_MASS_ARCHIVER,
  ACTION_MASS_IMPRESSSION,
  ACTION_MASS_DEMONTER,
} from '@/configuration/general/actionsConf';
import {
  getSelectionMessage,
  getSelectionColor,
} from '@/services/gabed/patrimoine/patrimoineSelection';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import popUpManageSecteur from '@/components/commun/secteur/p_manageSecteur';
import { PATRIMOINE } from '@/configuration/parametrage/secteurConf';
import { getSecteursByIds } from '@/services/commun/secteur/getSecteurs';
import translatorSecteurDispositifs from '@/services/secteur/translatorSecteurDispositif';
import selecteurAction from '@/components/general/selecteurAction';
import exportExcel from '@/api/exportExcel';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import validationDemandeImpression from '@/services/logistique/demandeImpression/validationDemandeImpression';
import popUpImpression from '@/components/logistique/demandeImpression/popUpImpression';
import popUpUpdateEtat from '@/components/general/popUpUpdateEtat';
import validationSuppression from '@/services/gabed/dispositif/validationSuppression';
import { TIERS } from '@/configuration/permissionsBodacConf';
import validationSecteur from '@/services/commun/secteur/validationSecteur';

const Permissions = createNamespacedHelpers('permissions');
const Societe = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');
const User = createNamespacedHelpers('user');

export default {
  name: 'l_dispositif',
  props: {
    isSelectable: {
      type: Boolean,
      default: false,
    },
    selection: {
      type: Object,
      required: false,
    },
    typePatrimoineSelected: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      constantes: {
        EPHEMERAL_DISPOSITIF_STORE,
        SELECTION_STATE,
        DISPOSITIF,
        MATERIEL,
        FACE,
        PATRIMOINE,
        ACTION_MASS_AJOUTER_SECTEUR,
        ACTION_MASS_DEMONTER,
        ACTION_MASS_ARCHIVER,
        TYPE_DONNEE_DISPOSITIF,
        ACTION_MASS_IMPRESSSION,
        DEMONTE,
      },
      errors: [],
      permEmplacement: EMPLACEMENT,
      permClientsContacts: TIERS,
      unsubscribeValue: null,
      showFiltre: false,
      startArrayRendering: false,
      mountedLoadingEnd: false,
      errorPopUp: false,
      openPopUpPrevention: false,
      popUpChangementEtatEnMasse: false,
      messagesErreurPopUp: [],
      referenceTable: REFERENCE_TABLE_DISPOSITIF,
      resultPerPage: RESULTS_PER_PAGE,
      withoutImage: true,
      popUpActionSecteur: false,
      actionSelected: null,
      func: {
        validationSecteur,
        translatorSecteurDispositifs,
      },
      openPopUpImpressionEnMasse: false,
      dispositifToDelete: null,
      openPopUpPreventionSuppression: false,
    };
  },
  components: {
    TableItemsInView,
    filtreListeDispositif,
    popUpPrevention,
    parametrageTable,
    imageView,
    tagList,
    BtnActionIcon,
    selecteurAction,
    popUpManageSecteur,
    popUpUpdateEtat,
    exportExcelButton,
    errorMsgComponent,
    popUpImpression,
    routerLinkBlank,
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      agencesSelectionnees: 'agenceActive',
      societeActive: 'societeActive',
      lockMenu: 'lockMenu',
    }),
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...User.mapGetters({
      user: 'user',
    }),
    storeName() {
      return this.isSelectable ? this.constantes.EPHEMERAL_DISPOSITIF_STORE : 'dispositif';
    },
    dispositifs() {
      return this.$store.getters[`${this.storeName}/items`];
    },
    total() {
      return this.$store.getters[`${this.storeName}/totalCount`];
    },
    criteresRecherche: {
      get() {
        return this.$store.getters[`${this.storeName}/criteresRecherche`];
      },
      set(value) {
        this.$store.commit(`${this.storeName}/SET_CRITERE`, value);
      },
    },
    lastPayload() {
      return this.$store.getters[`${this.storeName}/lastPayload`];
    },
    allInSelection() {
      return this.dispositifs.every(p => this.selection.dispositifs.find(s => s.id === p.id));
    },
    getFilteredNumber() {
      const banCritere = ['auto', 'actif', 'avecCoordonnees'];
      if (this.societeActive.agences.length === 1) banCritere.push('agencesId');
      let nbFiltre = calculNombreCritere(this.criteresRecherche, banCritere);
      if (!this.criteresRecherche.hasSecteur
        && this.criteresRecherche.hasSecteur !== null) nbFiltre += 1;
      nbFiltre += this.criteresRecherche.actif !== null ? 1 : 0;
      nbFiltre += this.criteresRecherche.avecCoordonnees !== null ? 1 : 0;
      if (nbFiltre > 9) return '9+';
      return nbFiltre;
    },
    moduleEmplacementClientActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleEmplacementClient.key);
    },
    dispositifsSelectedIsEmpty() {
      return this.dispositifs.filter((d) => d.selected).length > 0;
    },
    isArchiveOrNot() {
      return this.getAllDispositifSelected().find(el => el.actif);
    },
    iconSelectTotal() {
      if (this.allDispositifSelected) {
        return 'checkbox-multiple-marked-outline';
      }
      return 'checkbox-multiple-blank-outline';
    },
    allDispositifSelected() {
      return this.dispositifs.every(d => d.selected);
    },
    columns() {
      const columns = ['selected', 'addSelection', 'image', 'code', 'emplacement.client.nomCommercial', 'nom',
        'dispositifType.libelle', 'dispositifSupport.libelle', 'etat', 'adresse.adresse1', 'actif', 'agence', 'edit', 'archiver', 'delete'];
      if (this.societeActive.agences.length === 1) {
        columnsSplice(columns, 'agence');
      }
      if (this.withoutImage) columnsSplice(columns, 'image');
      if (this.isSelectable) {
        columnsSplice(columns, 'edit');
        columnsSplice(columns, 'archiver');
        columnsSplice(columns, 'delete');
        columnsSplice(columns, 'selected');
      } else {
        columnsSplice(columns, 'addSelection');
      }
      if (!this.moduleEmplacementClientActive) {
        columnsSplice(columns, 'emplacement.client.nomCommercial');
        columnsSplice(columns, 'nom');
      }
      return columns;
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          code: this.$i18n.t('listeDispositif.tab.code'),
          'emplacement.client.nomCommercial': this.$i18n.t('listeDispositif.tab.nomCommercial'),
          nom: this.$i18n.t('listeDispositif.tab.nom'),
          'dispositifType.libelle': this.$i18n.t('listeDispositif.tab.type'),
          'dispositifSupport.libelle': this.$i18n.t('listeDispositif.tab.support'),
          etat: this.$i18n.t('listeDispositif.tab.etatMontage'),
          'adresse.adresse1': this.$i18n.t('listeDispositif.tab.adresse'),
          agence: this.$i18n.t('listeMateriel.tab.agence'),
          actif: this.$i18n.t('listeDispositif.tab.archive'),
          edit: '',
          archiver: '',
          delete: '',
          selected: (h) => {
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    this.selectAll();
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
          addSelection: (h) => {
            return h(
              'button', {
                attrs: {
                  class: `ripple button width-100percent ${this.allInSelection ? 'is-success' : 'is-primary'}`,
                },
                on: {
                  click: () => {
                    this.manageAllInSelection();
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: 'plus-circle',
                  },
                }),
              ],
            );
          },
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: this.resultPerPage,
        texts: TEXTS,
        requestFunction: ((data) => {
          data.withoutImage = this.withoutImage;
          if (this.criteresRecherche.agencesId.length === 0) {
            this.criteresRecherche.agencesId = this.agencesSelectionnees
              .map(agence => agence.agenceId);
          }
          data.query = cloneDeep(this.criteresRecherche);
          if (data.query.datesMontage) {
            data.query.datesMontage.dateDebut = formatIsoDate(data.query.datesMontage.dateDebut);
            data.query.datesMontage.dateFin = formatIsoDate(data.query.datesMontage.dateFin);
          }
          if (data.query.datesDemontage) {
            data.query.datesDemontage.dateDebut = formatIsoDate(
              data.query.datesDemontage.dateDebut,
            );
            data.query.datesDemontage.dateFin = formatIsoDate(data.query.datesDemontage.dateFin);
          }
          data.query.clientIds = tagInputToArray(this.criteresRecherche.clients, 'id');
          data.query.tagIds = tagInputToArray(this.criteresRecherche.tagIds, 'id');
          delete data.query.clients;
          data.query.societeId = this.societeActiveId;
          return this.loadDispositifs(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.dispositifs,
            count: this.total,
          };
        }),
        columnsClasses: {
          edit: 'colonneSelected',
          archiver: 'colonneSelected',
          delete: 'colonneSelected',
          addSelection: 'colonneSelected',
          selected: 'colonneSelected',
        },
        sortable: ['code', 'emplacement.client.nomCommercial', 'nom', 'dispositifType.libelle', 'dispositifSupport.libelle', 'etat', 'adresse.adresse1'],
      };
    },
    exportExcelQuery() {
      return {
        typeDonnee: TYPE_DONNEE_DISPOSITIF,
        Filtres: this.lastPayload,
      };
    },
    moduleSecteurActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleSecteur.key);
    },
    actions() {
      const actions = [
        {
          action: ACTION_MASS_DEMONTER,
          translation: 'listeDispositif.actions.demonter',
          show: true,
        },
        {
          action: ACTION_MASS_AJOUTER_SECTEUR,
          translation: 'listeDispositif.actions.ajouterSecteur',
          show: this.moduleSecteurActive,
        },
        {
          action: ACTION_MASS_SUPPRIMER_SECTEUR,
          translation: 'listeDispositif.actions.supprimerSecteur',
          show: this.moduleSecteurActive,
        },
        {
          action: ACTION_MASS_IMPRESSSION,
          translation: 'listeDispositif.actions.impression',
          show: this.moduleEmplacementClientActive,
        },
        {
          action: ACTION_MASS_ARCHIVER,
          translation: 'listeDispositif.actions.archivageDispositif',
          show: true,
        },
      ];
      return actions.filter(a => a.show);
    },
    secondaryActions() {
      const actions = [];
      if (this.moduleEmplacementClientActive) {
        actions.push({
          libelle: this.$t('listeDispositif.exportTempsFort'),
          query: {
            typeDonnee: TYPE_DONNEE_DISPOSITIF,
            TypeExport: TYPE_EXPORT_DISPOSITIF_TEMPS_FORT,
            Filtres: cloneDeep(this.lastPayload),
          },
        });
      }
      return actions;
    },
  },
  filters: {
    adresse(adresse) {
      return adressFullStringGetter(adresse);
    },
  },
  methods: {
    loadDispositifs(data) {
      return this.$store.dispatch(`${this.storeName}/loadDispositifs`, data);
    },
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
      loadParametresInterne: 'loadParametresInterne',
    }),
    ...Societe.mapMutations({
      setLockMenu: SET_LOCK_MENU,
    }),
    hasClient(dispositif) {
      return !!dispositif.emplacement?.clientId;
    },
    getClientId(row) {
      return row.emplacement?.clientId ?? '';
    },
    getNomClient(row) {
      return row.emplacement?.client?.nomCommercial ?? '';
    },
    async reinitialiserFiltre() {
      await this.$refs.filtreListeDispositif.initializeFiltre();
      this.$refs.filtreListeDispositif.viderCritere();
      this.$refs.filtreListeDispositif.appliquerCritere();
      this.showFiltre = false;
    },
    inProgress(message) {
      inProgress(this.$i18n, message);
    },
    updateAgenceAndRecherche() {
      this.criteresRecherche.agencesId = this.agencesSelectionnees.map((agence) => agence.agenceId);
      this.recherche();
    },
    getAgenceLibelle(agenceId) {
      const agenceActiveFind = this.agencesSelectionnees.find((agence) => {
        return agence.agenceId === agenceId;
      });
      if (agenceActiveFind) return agenceActiveFind.libelleAgence;
      return '';
    },
    getListeTags(tags) {
      if (!tags.length) return [];
      return tags.map(t => t.tag);
    },
    getDataBody() {
      return {
        query: {
          societeId: this.societeActiveId,
        },
      };
    },
    getSelectionState(row) {
      const dispositifsSelected = this.selection.dispositifs.find(d => d.id === row.id);
      if (!dispositifsSelected) return this.constantes.SELECTION_STATE.UNSELECTED;

      if (this.selection.materiels
        .filter(m => m.dispositifId === row.id).length === row.materiels.length
        || this.typePatrimoineSelected === this.constantes.DISPOSITIF) {
        return this.constantes.SELECTION_STATE.SELECTED;
      }
      return this.constantes.SELECTION_STATE.SELECTED_PARTIALLY;
    },
    getSelectionButtonColor(selection) {
      return getSelectionColor(this.getSelectionState(selection));
    },
    getSelectionButtonMessage(selection) {
      return getSelectionMessage(this.getSelectionState(selection));
    },
    isInSelection(row) {
      return this.selection.dispositifs.find(f => f.id === row.id);
    },
    validationPopUp() {
      this.popUpChangementEtatEnMasse = false;
      this.recherche();
    },
    manageAllInSelection() {
      if (this.allInSelection) {
        this.$emit('removeSelection', this.dispositifs);
      } else {
        this.$emit('addSelection', this.dispositifs);
      }
    },
    makeRechercheFilter(critereUpdate) {
      this.criteresRecherche = critereUpdate;
      if (this.showFiltre) this.setShowFiltre();
      this.recherche();
    },
    async setShowFiltre() {
      this.showFiltre = !this.showFiltre;
      if (this.showFiltre) await this.$refs.filtreListeDispositif.initializeFiltre();
      this.setLockMenu(!this.lockMenu);
    },
    getDispositifTypeLibelle(id) {
      const dispositifFind = this.parametre(PARAMETRES_KEYS.dispositifType).find((dispositif) => {
        return dispositif.id === id;
      });
      return dispositifFind ? dispositifFind.libelle : '';
    },
    getEtatMontage(codeEtat) {
      const etatFind = ETAT_DISPOSITIF_PUBLICITAIRE.find((etat) => {
        return etat.value === codeEtat;
      });
      return etatFind ? etatFind.libelle : null;
    },
    goFirstPage() {
      this.$refs[this.referenceTable].setPage(1);
    },
    recherche() {
      this.$refs[this.referenceTable].refresh();
    },
    finLoading() {
      this.loadingComponent.close();
    },
    debutLoading() {
      if (this.loadingComponent) this.loadingComponent.close();
      this.loadingComponent = this.$buefy.loading.open();
    },
    showPopUpArchivage(dispositifToArchive) {
      this.errorPopUp = false;
      this.messagesErreurPopUp = [];
      dispositifToArchive.selected = true;
      this.openPopUpPrevention = true;
    },
    async archiverDispositif() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.errorPopUp = false;
        this.messagesErreurPopUp = [];
        if (this.getAllDispositifSelected().length > 0) {
          const elemSelected = this.getAllDispositifSelected();
          const ids = elemSelected.map(el => el.id);
          this.actif = elemSelected.some(el => el.actif);
          await archiverAll(ids, this.actif);
        }
        messageSucces(this.$i18n.t('listeDispositif.messages.success.' + (this.actif ? 'archivage' : 'desarchivage')));
        this.openPopUpPrevention = false;
        loadingComponent.close();
        this.recherche();
      } catch (e) {
        if (e.response.data.error) {
          validationDispositif(e.response, this.messagesErreurPopUp);
          this.errorPopUp = true;
        } else messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    async exportExcel(typeExport) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const response = await exportExcel({
          typeDonnee: TYPE_DONNEE_DISPOSITIF,
          TypeExport: typeExport,
          Filtres: this.lastPayload,
        });
        const link = this.$refs.lienDownload;
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
    manageActions(action) {
      this.actionSelected = action;
      switch (action) {
        case ACTION_MASS_AJOUTER_SECTEUR:
        case ACTION_MASS_SUPPRIMER_SECTEUR:
          if (this.checkPermissions(this.permEmplacement.maj)) {
            this.popUpActionSecteur = true;
          } else {
            this.showPopUp();
          }
          break;
        case ACTION_MASS_DEMONTER:
          if (this.checkPermissions(this.permEmplacement.maj)) {
            this.popUpChangementEtatEnMasse = true;
          } else this.showPopUp();
          break;
        case ACTION_MASS_IMPRESSSION:
          if (this.checkPermissions(this.permEmplacement.editer)) {
            this.openPopUpImpressionEnMasse = true;
          } else this.showPopUp();
          break;
        case ACTION_MASS_ARCHIVER:
          if (this.checkPermissions(this.permEmplacement.supprimer)) {
            this.messagesErreurPopUp = [];
            this.errorPopUp = false;
            this.openPopUpPrevention = true;
          } else this.showPopUp();
          break;
        default:
          messageErreur(this.$i18n, this.$i18n.t('listeFace.errors.noActionSelect'));
          break;
      }
    },
    async genererImpresssions(impressionInfo) {
      const loadingComponent = this.$buefy.loading.open();
      this.openPopUpImpressionEnMasse = false;
      try {
        const data = {
          dispositifIds: this.dispositifs.filter((el) => el.selected).map((el) => el.id),
          dateDemande: formatIsoDate(impressionInfo.date),
          campagneId: impressionInfo.campagnePourImpression?.campagneId,
        };
        await genererDemandeImpression(data);
        messageSucces(this.$i18n.t('editionDemandeImpression.success.impressionEnMasse'));
      } catch (e) {
        validationDemandeImpression(e.response, this.errors);
        messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
    closePopUpImpression() {
      this.openPopUpImpressionEnMasse = false;
    },
    getAllDispositifSelected() {
      return this.dispositifs.filter((el) => {
        return el.selected;
      });
    },
    selectAll() {
      const select = !this.allDispositifSelected;
      this.dispositifs.forEach((dispositif) => {
        dispositif.selected = select;
      });
    },
    async actionSecteur(payload) {
      if (this.actionSelected === ACTION_MASS_AJOUTER_SECTEUR) {
        await ajoutSecteurAsync(payload);
      } else {
        await suppressionSecteurAsync(payload);
      }
      await this.recherche();
    },
    showPopUpSuppression(dispositifToDelete) {
      this.errorPopUp = false;
      this.messagesErreurPopUp = [];
      this.dispositifToDelete = dispositifToDelete;
      this.openPopUpPreventionSuppression = true;
    },
    async supprimerDispositif() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.errorPopUp = false;
        this.messagesErreurPopUp = [];
        await supprimer(this.dispositifToDelete.id);
        messageSucces(this.$t('dispositifPublicitaire.messages.success.supprimer'));
        this.openPopUpPreventionSuppression = false;
        this.recherche();
      } catch (e) {
        if (e.response.data.error) {
          validationSuppression(e.response, this.messagesErreurPopUp);
          this.errorPopUp = true;
        } else messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
  },
  beforeDestroy() {
    if (this.lockMenu) this.setLockMenu(false);
    this.unsubscribeValue();
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.unsubscribeValue = await subscribeMutation(this.$store, 'societe/' + SET_DETECT_CHANGE_SOCIETE, this.updateAgenceAndRecherche, this.goFirstPage);
      await this.loadParametresInterne([
        PARAMETRES_INTERNE_KEYS.moduleEmplacementClient.key,
        PARAMETRES_INTERNE_KEYS.moduleSecteur.key,
      ]);
      await this.loadParametres([PARAMETRES_KEYS.dispositifType]);
      this.criteresRecherche.agencesId = this.agencesSelectionnees.map((agence) => agence.agenceId);
      if (this.moduleSecteurActive) {
        const targetSecteur = await getSecteursByIds(this.user.secteursId, PATRIMOINE);
        if (targetSecteur.length > 0) {
          this.criteresRecherche.secteurs = targetSecteur.map(ts => ts.id);
        }
      }
      if (this.$route.params.tiersId) {
        const client = (await get(this.$route.params.tiersId)).data.result;
        this.criteresRecherche.clients = [client];
      }
      this.mountedLoadingEnd = true;
    } catch (e) {
      messageErreur(this.$i18n);
      throw e;
    } finally {
      loadingComponent.close();
    }
  },
};

</script>
